var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.517578,
    width: 53,
    height: 53,
    rx: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.517578,
    width: 53,
    height: 53,
    rx: 1.5,
    stroke: "#5522E2",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeDasharray: "6 8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6.90146L35.159 15.0613L30.965 20.211L28.3273 22.8424L28.327 22.8426C27.9745 23.1948 27.4966 23.3926 26.9983 23.3926C26.5001 23.3926 26.0222 23.1948 25.6696 22.8426L25.6695 22.8425L23.0334 20.2112L18.8409 15.0598L27 6.90146Z",
    stroke: "#5522E2",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.9015L35.159 39.0613L30.965 44.211L28.3273 46.8424L28.327 46.8426C27.9745 47.1948 27.4966 47.3926 26.9983 47.3926C26.5001 47.3926 26.0222 47.1948 25.6696 46.8426L25.6695 46.8425L23.0334 44.2112L18.8409 39.0598L27 30.9015Z",
    stroke: "#5522E2",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.9015L23.159 27.0613L18.965 32.211L16.3273 34.8424L16.327 34.8426C15.9745 35.1948 15.4966 35.3926 14.9983 35.3926C14.5001 35.3926 14.0222 35.1948 13.6696 34.8426L13.6695 34.8425L11.0334 32.2112L6.84087 27.0598L15 18.9015Z",
    stroke: "#5522E2",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18.9015L47.159 27.0613L42.965 32.211L40.3273 34.8424L40.327 34.8426C39.9745 35.1948 39.4966 35.3926 38.9983 35.3926C38.5001 35.3926 38.0222 35.1948 37.6696 34.8426L37.6695 34.8425L35.0334 32.2112L30.8409 27.0598L39 18.9015Z",
    stroke: "#5522E2",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.0aee1d88fce62ae21fc80989ded0f1f1.svg";
export { ForwardRef as ReactComponent };